export enum ReplacementOptions {
  Blue = "Blue",
  Beach = "Beach",
}

export enum ReplacementType {
  Color,
  Image,
}

export type ReplacementDropdownOptionType = {
  label: ReplacementOptions;
  type: ReplacementType;
  value: string;
};

export type BackgroundOption = ReplacementOptions | "none" | "blur";
